"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _HTTPValidationError = _interopRequireDefault(require("../model/HTTPValidationError"));
var _RentalItem = _interopRequireDefault(require("../model/RentalItem"));
var _RentalItemCreate = _interopRequireDefault(require("../model/RentalItemCreate"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * KFV LDS API
 * Die KFV LDS API bietet eine Schnittstelle zum Backend der PWA.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
* RentalItems service.
* @module api/RentalItemsApi
* @version 0.0.1
*/
class RentalItemsApi {
  /**
  * Constructs a new RentalItemsApi. 
  * @alias module:api/RentalItemsApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  constructor(apiClient) {
    this.apiClient = apiClient || _ApiClient.default.instance;
  }

  /**
   * Callback function to receive the result of the createRentalItemMaterialPost operation.
   * @callback module:api/RentalItemsApi~createRentalItemMaterialPostCallback
   * @param {String} error Error message, if any.
   * @param {module:model/RentalItem} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Create Rental Item
   * @param {module:model/RentalItemCreate} rentalItemCreate 
   * @param {module:api/RentalItemsApi~createRentalItemMaterialPostCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link module:model/RentalItem}
   */
  createRentalItemMaterialPost(rentalItemCreate, callback) {
    let postBody = rentalItemCreate;
    // verify the required parameter 'rentalItemCreate' is set
    if (rentalItemCreate === undefined || rentalItemCreate === null) {
      throw new Error("Missing the required parameter 'rentalItemCreate' when calling createRentalItemMaterialPost");
    }
    let pathParams = {};
    let queryParams = {};
    let headerParams = {};
    let formParams = {};
    let authNames = ['JWTBearer'];
    let contentTypes = ['application/json'];
    let accepts = ['application/json'];
    let returnType = _RentalItem.default;
    return this.apiClient.callApi('/material/', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
  }

  /**
   * Callback function to receive the result of the deleteRentalItemMaterialItemIdDelete operation.
   * @callback module:api/RentalItemsApi~deleteRentalItemMaterialItemIdDeleteCallback
   * @param {String} error Error message, if any.
   * @param {Object} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Delete Rental Item
   * @param {Number} itemId 
   * @param {module:api/RentalItemsApi~deleteRentalItemMaterialItemIdDeleteCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link Object}
   */
  deleteRentalItemMaterialItemIdDelete(itemId, callback) {
    let postBody = null;
    // verify the required parameter 'itemId' is set
    if (itemId === undefined || itemId === null) {
      throw new Error("Missing the required parameter 'itemId' when calling deleteRentalItemMaterialItemIdDelete");
    }
    let pathParams = {
      'item_id': itemId
    };
    let queryParams = {};
    let headerParams = {};
    let formParams = {};
    let authNames = ['JWTBearer'];
    let contentTypes = [];
    let accepts = ['application/json'];
    let returnType = Object;
    return this.apiClient.callApi('/material/{item_id}', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
  }

  /**
   * Callback function to receive the result of the getRentalItemMaterialItemIdGet operation.
   * @callback module:api/RentalItemsApi~getRentalItemMaterialItemIdGetCallback
   * @param {String} error Error message, if any.
   * @param {module:model/RentalItem} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Get Rental Item
   * @param {Number} itemId 
   * @param {module:api/RentalItemsApi~getRentalItemMaterialItemIdGetCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link module:model/RentalItem}
   */
  getRentalItemMaterialItemIdGet(itemId, callback) {
    let postBody = null;
    // verify the required parameter 'itemId' is set
    if (itemId === undefined || itemId === null) {
      throw new Error("Missing the required parameter 'itemId' when calling getRentalItemMaterialItemIdGet");
    }
    let pathParams = {
      'item_id': itemId
    };
    let queryParams = {};
    let headerParams = {};
    let formParams = {};
    let authNames = [];
    let contentTypes = [];
    let accepts = ['application/json'];
    let returnType = _RentalItem.default;
    return this.apiClient.callApi('/material/{item_id}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
  }

  /**
   * Callback function to receive the result of the getRentalItemsMaterialGet operation.
   * @callback module:api/RentalItemsApi~getRentalItemsMaterialGetCallback
   * @param {String} error Error message, if any.
   * @param {Array.<module:model/RentalItem>} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Get Rental Items
   * @param {Object} opts Optional parameters
   * @param {Date} [start] 
   * @param {Date} [end] 
   * @param {module:api/RentalItemsApi~getRentalItemsMaterialGetCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link Array.<module:model/RentalItem>}
   */
  getRentalItemsMaterialGet(opts, callback) {
    opts = opts || {};
    let postBody = null;
    let pathParams = {};
    let queryParams = {
      'start': opts['start'],
      'end': opts['end']
    };
    let headerParams = {};
    let formParams = {};
    let authNames = [];
    let contentTypes = [];
    let accepts = ['application/json'];
    let returnType = [_RentalItem.default];
    return this.apiClient.callApi('/material/', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
  }

  /**
   * Callback function to receive the result of the updateRentalItemMaterialItemIdPut operation.
   * @callback module:api/RentalItemsApi~updateRentalItemMaterialItemIdPutCallback
   * @param {String} error Error message, if any.
   * @param {module:model/RentalItem} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Update Rental Item
   * @param {Number} itemId 
   * @param {module:model/RentalItemCreate} rentalItemCreate 
   * @param {module:api/RentalItemsApi~updateRentalItemMaterialItemIdPutCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link module:model/RentalItem}
   */
  updateRentalItemMaterialItemIdPut(itemId, rentalItemCreate, callback) {
    let postBody = rentalItemCreate;
    // verify the required parameter 'itemId' is set
    if (itemId === undefined || itemId === null) {
      throw new Error("Missing the required parameter 'itemId' when calling updateRentalItemMaterialItemIdPut");
    }
    // verify the required parameter 'rentalItemCreate' is set
    if (rentalItemCreate === undefined || rentalItemCreate === null) {
      throw new Error("Missing the required parameter 'rentalItemCreate' when calling updateRentalItemMaterialItemIdPut");
    }
    let pathParams = {
      'item_id': itemId
    };
    let queryParams = {};
    let headerParams = {};
    let formParams = {};
    let authNames = ['JWTBearer'];
    let contentTypes = ['application/json'];
    let accepts = ['application/json'];
    let returnType = _RentalItem.default;
    return this.apiClient.callApi('/material/{item_id}', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
  }
}
exports.default = RentalItemsApi;